import type { ComponentType } from 'react'
import { DocumentCards } from './DocumentCards'
import { DOCUMENTS_ATTACHMENT, DOCUMENT_ATTACHMENT } from './document-attachment'

// 附件渲染器註冊表（契約 §7.3.1）。#1620 重新接線：依工具結果的 attachmentType 挑渲染器。
// 🔴 目前只接公文卡片；里民、報名的表格渲染器維持停用（#1454），不列在這裡就畫不出來。

export interface AttachmentViewProps {
  /** 工具結果本身，也就是送給模型的那一份 */
  content: unknown
  /** 點了卡片要打開的東西；不給就是不能點的卡片 */
  onOpen?: (id: string) => void
}

export const ATTACHMENT_RENDERERS: Record<string, ComponentType<AttachmentViewProps>> = {
  [DOCUMENTS_ATTACHMENT]: DocumentCards,
  [DOCUMENT_ATTACHMENT]: DocumentCards,
}

/** 工具結果上的 attachmentType；沒有或不是字串就回 null。 */
export const readAttachmentType = (output: unknown): string | null => {
  const type = (output as { attachmentType?: unknown } | null)?.attachmentType
  return typeof type === 'string' ? type : null
}

// 🔴 認不得或停用中的型別一律不畫，不退回通用表格：退回去等於把停用的附件重新打開。
export const resolveAttachmentRenderer = (
  attachmentType: string | null,
): ComponentType<AttachmentViewProps> | null =>
  (attachmentType !== null && Object.prototype.hasOwnProperty.call(ATTACHMENT_RENDERERS, attachmentType) ?
    ATTACHMENT_RENDERERS[attachmentType] : null)
